export default {
  detail: 'Detail',
  good: 'SKU Detail',
  promo: 'Promo Detail',
};
